export function isLikelyMetaPayloadText(value: unknown): boolean {
  if (typeof value !== 'string') return false;

  const trimmed = value.trim();
  if (!trimmed) return false;

  // Remove tags para cobrir casos como <div>{...json...}</div>.
  const withoutTags = trimmed.replace(/<[^>]*>/g, ' ');
  const decoded = withoutTags
    .replace(/&quot;/gi, '"')
    .replace(/&#34;/gi, '"')
    .replace(/&amp;/gi, '&');
  const normalized = decoded.replace(/\s+/g, ' ').trim();

  if (!normalized) return false;

  const hasDataArray = /"data"\s*:\s*\[/i.test(normalized);
  const hasEventName = /"event_name"\s*:\s*"[a-z0-9_ -]+"/i.test(normalized);
  const hasActionSource = /"action_source"\s*:\s*"[a-z0-9_ -]+"/i.test(normalized);
  const hasUserData = /"user_data"\s*:\s*\{/i.test(normalized);

  return hasDataArray && hasEventName && hasActionSource && hasUserData;
}
